import useFeatureFlag from '@/components/hooks/useFeatureFlag';
import { useSeekerCCState } from '@/components/AppState';
import { CLIENT_FEATURE_FLAGS, VERTICALS_NAMES } from '@/constants';
import { ServiceIdsForMember } from '@/types/seekerCC';
import getVertical from '@/utilities/verticalUtils';

export function useCondensedAccountCreation() {
  const vertical = getVertical();
  const { czenServiceIdForMember } = useSeekerCCState();
  const condensedAccountCreateFlag = useFeatureFlag(
    CLIENT_FEATURE_FLAGS.GROWTH_ENROLLMENT_CC_CONDENSE_ACCOUNT_CREATION
  );
  const isCondensedAccountCreateEligible =
    czenServiceIdForMember !== ServiceIdsForMember.dayCare &&
    vertical === VERTICALS_NAMES.CHILD_CARE;
  const isCondensedAccountCreateEnabled =
    condensedAccountCreateFlag?.value === 2 && isCondensedAccountCreateEligible;

  return {
    condensedAccountCreateFlag,
    isCondensedAccountCreateEligible,
    isCondensedAccountCreateEnabled,
  };
}
